export * from "./ns-accordion/ns-accordion.js";
export * from "./ns-accordion/ns-accordion-item.js";
export * from "./ns-action-menu/ns-action-menu.js";
export * from "./ns-action-menu-segmented/ns-action-menu-segmented.js";
export * from "./ns-alert/ns-alert.js";
export * from "./ns-badge/ns-badge.js";
export * from "./ns-blockload/ns-blockload.js";
export * from "./ns-brand-content/ns-brand-content.js";
export * from "./ns-breadcrumb/ns-breadcrumb.js";
export * from "./ns-button/ns-button.js";
export * from "./ns-card/ns-card.js";
export * from "./ns-dialog/ns-dialog.js";
export * from "./ns-event-button/ns-event-button.js";
export * from "./ns-expressive-link/ns-expressive-link.js";
export * from "./ns-searchbar/ns-searchbar-legacy.js";
export * from "./ns-global-loader/ns-global-loader.js";
export * from "./ns-footer/ns-footer-nav-deprecated.js";
export * from "./ns-hero/ns-hero-legacy.js";
export * from "./ns-iconset/ns-iconset.js";
export * from "./ns-iconset/ns-iconset-color.js";
export * from "./ns-iconset/ns-iconset-24.js";
export * from "./ns-iconset/ns-iconset-lg.js";
export * from "./ns-image/ns-image.js";
export * from "./ns-information-card/ns-information-card.js";
export * from "./ns-layout/ns-layout.js";
export * from "./ns-logo/ns-logo.js";
export * from "./ns-number-increment/ns-number-increment.js";
export * from "./ns-overlay/ns-overlay.js";
export * from "./ns-promo-band/ns-promo-band.js";
export * from "./ns-promo-hero/ns-promo-hero.js";
export * from "./ns-quiq-chat-button/ns-quiq-chat-button.js";
export * from "./ns-region-selector/ns-region-selector.js";
export * from "./ns-region/ns-region.js";
export * from "./ns-region-selection/ns-region-selection.js";
export * from "./ns-search-results-page/ns-search-results-page.js";
export * from "./ns-social-icons/ns-social-icons.js";
export * from "./ns-spinner/ns-spinner.js";
export * from "./ns-toast/ns-toast.js";
export * from "./ns-tile/ns-tile.js";
export * from "./recognition/ns-recognition/ns-recognition.js";
export * from "./ns-featured-panel/ns-featured-panel/ns-featured-panel.js";
export * from "./ns-application/ns-application.js";
export * from "./ns-login-modal/ns-login-modal.js";
export * from "./ns-quantity-selector/ns-quantity-selector.js";
export * from "./ns-skeleton-carousel/ns-skeleton-carousel.js";
export * from "./ns-upload-image/ns-upload-image.js";
export * from "./ns-sortable/ns-sortable.js";
export * from "./ns-combo-select/ns-combo-select.js";
export * from "@polymer/app-layout/app-drawer/app-drawer.js";
export * from "@polymer/app-layout/app-drawer-layout/app-drawer-layout.js";
export * from "@polymer/paper-dropdown-menu/paper-dropdown-menu.js";
export * from "@polymer/app-layout/helpers/helpers.js";

export * from "./ns-stepper/ns-stepper.js";
export * from "./ns-stepper/ns-step.js";

import Vue from "vue";
import nsAlert from "./ns-alert-vue/ns-alert.vue";
import nsGlobalLoaderVue from "./ns-global-loader/ns-global-loader-vue.vue";
import nsIcon from "./ns-icon-vue/ns-icon.vue";
import nsMessageAction from "./ns-message-action/ns-message-action.vue";
import nsQuiqChatButtonVue from "./ns-quiq-chat-button/ns-quiq-chat-button-vue.vue";
import nsSecondaryNav from "./ns-secondary-nav/ns-secondary-nav.vue";
import nsStickyNav from "./ns-sticky-nav/ns-sticky-nav.vue";
import nsToastVue from "./ns-toast/ns-toast-vue.vue";

// Add vue components in this object to get registered and exported in aem bundle
const Components = {
  nsAlert,
  nsGlobalLoaderVue,
  nsIcon,
  nsMessageAction,
  nsQuiqChatButtonVue,
  nsSecondaryNav,
  nsStickyNav,
  nsToastVue
};

Object.keys(Components).forEach((name) => {
  Vue.component(name, Components[name]);
});
